


















































































































































































































































import Vue from 'vue'
import firebase from 'firebase'
import 'firebase/auth'
import { userAvatarImage } from '../../helper/constants'
import UserAvatar from '@/components/common/UserAvatar.vue'
import { adminMode } from '../../helper/permission.helper'
import { getThemeClasses } from '../../helper'
import { getFeatureFlag } from '@/services'
import MobileNavigation from './MobileNavigation.vue'
export default Vue.extend({
  components: {
    UserAvatar,
    MobileNavigation
  },
  props: {
    logo: {
      type: String
    },
    showLogo: {
      type: Boolean,
      default: true
    },
    alignment: {
      type: String,
      default: 'between'
    },
    backCallback: {
      type: Function
    }
  },
  data() {
    return {
      open: false,
      openSettings: false,
      headerRoot: {
        'product-overview': 'navigation-header',
        'post-overview': 'lesson-navigation-header'
      },
      headerContainer: {
        'product-overview': 'header',
        'post-overview': 'lesson-header'
      }
    }
  },
  computed: {
    device(): string {
      return this.$store.getters.device
    },
    brandLogoUrl(): string {
      return this.logo || this.$store.state.logoUrl
    },
    userImage(): string {
      return this.$store.getters.userAvatar || userAvatarImage
    },
    isAdmin() {
      return adminMode()
    },
    libraryPath(): string {
      const featureFlag: any = getFeatureFlag()
      return featureFlag?.libraryV2 ? 'library-v2' : 'library'
    },
    newMobileScreens(): boolean {
      return this.$store.getters.newMobileScreens
    },
    isBuilder(): boolean {
      return this.$route.query.builder === 'true'
    }
  },
  methods: {
    signOut() {
      this.$cookies.remove('cat')
      if (localStorage) {
        try {
          localStorage.removeItem('cat')
        } catch (error) {
          // patch
        }
      }
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({ name: 'login' })
        })
    },
    openModal() {
      this.$bus.$emit('openSearchModal', true)
    },
    getThemeClasses
  }
})
